import React, { useState } from 'react'
import { Grid, Box, Tooltip, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import FormLabel from '@material-ui/core/FormLabel'
import Switch from '@material-ui/core/Switch'
import * as yup from 'yup'
import { Formik, Field } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import LiquidInput from '@src/components/LiquidInput'
import ValidationErrors from '../../../validations/ValidationErrors'
import ValidationWarnings from '../../../validations/ValidationWarnings'
import OligoNameWarning from '../../../validations/oligoNameWarning'
import { configContext } from '../../../utils/StandardReducer'
import {
  useRuleValidateFieldsMutation,
  useSessionFieldsMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import OligoNameInfoIcon from './OligoNameInfoIcon'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { TubeProperties, TubeProduct, Modification } from '../enum'
import {
  validateTextUpdated as validateText,
  convertToASCII,
} from '../../../utils/util'
import { ConfiguratorValues } from '../../../utils/constants'
import InfoIcon from '@material-ui/icons/Info'
import globalStyles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'
import { useGetProduct } from '@src/routes/Configurators/utils/useGetProduct'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(5, 5),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      margin: theme.spacing(4, 0),
    },
    tootltip: {
      marginBottom: theme.spacing(0.6),
    },
    baseCount: {
      fontSize: theme.typography.pxToRem(12),
      margin: theme.spacing(0, 0, 2),
    },
    baseContent: {
      fontSize: theme.typography.pxToRem(12),
    },
    switchLabel: {
      fontSize: theme.typography.pxToRem(12),
      color: '#1b1b25',
    },
    sequenceInput: {
      '&.Mui-error': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-error:hover': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '& input': {
        '&:-webkit-autofill': {
          transition: 'background-color 5000s ease-in-out 0s',
        },
      },
    },
    sequenceLabel: {
      '& label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.primary,
      margin: theme.spacing(0, 0, 2),
      display: 'inline-flex',
    },
    alignRight: {
      textAlign: 'right',
    },
    mt20: {
      marginTop: theme.spacing(5),
    },
    validateError: {
      marginLeft: theme.spacing(-4),
      marginTop: theme.spacing(-4),
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
    },
    icon: {
      fontSize: theme.typography.pxToRem(14),
      verticalAlign: 'middle',
      color: theme.palette.grey[700],
    },
    sequenceType: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      display: 'flex',
      alignItems: 'flex-end',
    },
    InfoPopup: {
      maxWidth: theme.spacing(65),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      border: `1px solid  ${theme.palette.common.white}`,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(4),
      fontSize: theme.typography.pxToRem(12),
      color: '#1b1b25',
      marginTop: theme.spacing(1.5),
    },
    arrow: {
      color: theme.palette.common.white,
    },
    InfoIcon: {
      outlined: true,
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(1.5),
      marginLeft: theme.spacing(1.5),
    },
    sequenceInfoIcon: {
      fontSize: theme.typography.pxToRem(16),
      verticalAlign: 'middle',
    },
    warningBox: {
      padding: theme.spacing(3, 0, 0, 0),
    },
    sequenceEntry: {
      wordBreak: 'break-all',
    },
    sequenceHelperText: {
      fontSize: theme.typography.pxToRem(12),
      padding: theme.spacing(2, 0, 0, 0),
    },
    radioControlStyle: {
      marginRight: theme.spacing(10),
      '& .MuiTypography-body1': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
  }
})
let insertPos = 0
let setPosition = false
const SequenceInfo = (props) => {
  const seqInput: any = document.getElementById('sequence')
  const classes = useStyles()
  const globalClasses = globalStyles()
  const { productDetails, setSequencePreviewData } = props
  const intl = useIntl()
  const [count, setCount] = useState<number>(0)
  const [sequenceValidation, setSequenceValidation] = useState<string[]>([])
  const [sequenceWarning, setSequenceWarning] = useState<string[]>([])
  const [isSequencekeyUp, setIsSequencekeyUp] = useState<boolean>(false)
  const sequenceKey = messages.CONF_SEQUENCE_TEXT.defaultMessage
  const { state, dispatch } = React.useContext(configContext)
  const product = useGetProduct()

  const {
    sessionData,
    currentOligoIndex,
    optionalBases,
    isPageLoad,
    callSessionAPI,
    isDeletePerform,
    aquaInternalMod,
    optionalBaseChanged,
    isTubePageLoad,
    totalValidationJSON,
    isTubeItemDelete,
    productInformation,
    focusOnSequenceBox,
    errorData,
  } = state

  const { instructions } = productInformation
  const [ruleValidateFields] = useRuleValidateFieldsMutation()
  const [isToggled, setToggle] = useState(false)
  const [sequence, setSequence] = useState<any>(
    sessionData[currentOligoIndex]?.sequence
  )
  const [validateNameErrors, setValidateNameErrors] = useState<string[]>([])
  const [sessionFields] = useSessionFieldsMutation()
  const nameKey = messages.CONF_OLIGO_NAME_KEY.defaultMessage
  const [oligoName, setOligoName] = useState<any>(
    sessionData[currentOligoIndex].name
  )

  const [isSessionAPICall, setSessionAPI] = useState<boolean>(true)
  const [isSequence, setIsSequence] = useState(false)
  const [isOligoNameChange, setIsOligoNameChange] = useState(false)
  const debouncedSequenceData = useDebounce(
    sequence,
    TubeProperties.SEQUENCE_API_TIME
  )

  const [isSeqEmpty, setSeqEmpty] = useState<boolean>(false)
  const [isToggleSelect, setIsToggleSelect] = useState<boolean>(false)
  const [newText, setNewText] = useState(0)

  const list: any = ['mA', 'mC', 'mG', 'mU']
  const isTwoMeBase = (modification) => {
    return list.includes(modification)
  }
  const oligoNameRegex =
    /^[a-zA-Z0-9_#*()., +.[\-\]/]*$|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g

  const setSequenceProperties = (data, isSequenceValid) => {
    if (!isSequenceValid) {
      let seq
      if (product === TubeProduct.Aqua || product === TubeProduct.Cpeptide) {
        seq = `${errorData.nterminalMod}${errorData.sequence.replace(
          /\s+/g,
          ''
        )}${errorData.cterminalMod}`
      } else {
        if (product === TubeProduct.Wellred) {
          const fiveMod =
            errorData.fiveMod.replace(/[[\]]/g, '') !== TubeProperties.None
              ? errorData.fiveMod
              : ''
          seq = `${fiveMod}${errorData.sequence.replace(/\s+/g, '')}`
        } else {
          const fiveModification = errorData.fiveMod
          const threeModification = errorData.threeMod
          let fiveMod = ''
          let threeMod = ''
          if (isTwoMeBase(fiveModification)) {
            fiveMod = '[' + fiveModification + ']'
          } else {
            fiveMod =
              errorData.fiveMod?.replace(/[[\]]/g, '') !== TubeProperties.None
                ? errorData.fiveMod
                : ''
          }

          if (isTwoMeBase(threeModification)) {
            threeMod = '[' + threeModification + ']'
          } else {
            threeMod =
              errorData.threeMod?.replace(/[[\]]/g, '') !== TubeProperties.None
                ? errorData.threeMod
                : ''
          }
          seq = `${fiveMod}${errorData.sequence.replace(/\s+/g, '')}${threeMod}`
        }
      }
      setSequencePreviewData({
        sequence: seq,
        baseCount: data.ruleValidateFields.baseCount,
        molecularWeight: data.ruleValidateFields.molecularWeight,
        secondaryStructure: data.ruleValidateFields.secondaryStructure
          ? intl.formatMessage(
              messages[data.ruleValidateFields.secondaryStructure]
            )
          : data.ruleValidateFields.secondaryStructure,
        primerDimer: data.ruleValidateFields.primerDimer,
        meltingTemperature: data.ruleValidateFields.meltingTemperature,
        gcContent: data.ruleValidateFields.gcContent,
      })
    } else {
      setSequencePreviewData({
        sequence:
          errorData.sequence.length === 0
            ? intl.formatMessage(messages.CONF_SEQUENCE_PREVIEW_HELP_TEXT)
            : '--',
        baseCount: '--',
        molecularWeight: '--',
        secondaryStructure: '--',
        primerDimer: '--',
        meltingTemperature: '--',
        gcContent: '--',
      })
    }
  }

  const ruleValidation = async (obj) => {
    if (
      isOligoNameChange === false &&
      (isSessionAPICall ||
        sessionData[currentOligoIndex].sequence?.length !== 0 ||
        sessionData[currentOligoIndex].name?.length !== 0 ||
        state.isViewAllClick ||
        state.isLabelledAminoAcidError)
    ) {
      const response = await ruleValidateFields({
        variables: { input: obj, productInput: productDetails },
      })
      const { data } = response
      if (data && !data.ruleValidateFields.serverError) {
        let isSeqInvalid = false
        if (data.ruleValidateFields.listErrors) {
          isSeqInvalid = data.ruleValidateFields.listErrors.some((item) =>
            item && item.key ? item.key === sequenceKey : false
          )
        }
        setSequenceProperties(data, isSeqInvalid)
        if (data.ruleValidateFields.molecularWeight !== undefined)
          sessionData[currentOligoIndex].molecularWeight =
            data.ruleValidateFields.molecularWeight
        if (data.ruleValidateFields.primerDimer !== undefined)
          sessionData[currentOligoIndex].primerDimer =
            data.ruleValidateFields.primerDimer
        if (data.ruleValidateFields.meltingTemperature !== undefined)
          sessionData[currentOligoIndex].meltingTemparature =
            data.ruleValidateFields.meltingTemperature
        if (data.ruleValidateFields.gcContent !== undefined)
          sessionData[currentOligoIndex].gcContent =
            data.ruleValidateFields.gcContent
        if (data.ruleValidateFields.secondaryStructure) {
          sessionData[currentOligoIndex].secondaryStructure =
            intl.formatMessage(
              messages[data.ruleValidateFields.secondaryStructure]
            )
        }

        const { listErrors } = data.ruleValidateFields
        const { listWarnings } = data.ruleValidateFields
        if (listErrors?.length === 0) {
          dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
        }

        if (listErrors) {
          if (listErrors?.length !== 0) {
            listErrors.forEach((item) => {
              if (item) delete item.__typename
            })
          }
          sessionData[currentOligoIndex].listError = listErrors
        }
        if (listWarnings) {
          if (listWarnings?.length !== 0) {
            listWarnings.forEach((item) => {
              if (item) delete item.__typename
            })
          }
          sessionData[currentOligoIndex].listWarning = listWarnings
        }

        dispatch({
          type: 'UPDATE_ERROR_RESPONSE',
          data: data.ruleValidateFields,
        })
        dispatch({
          type: 'IS_RESET_ERROR',
          data: true,
        })
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: ConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
  }

  const sessionDataToSession = async (obj) => {
    if ((isPageLoad !== 1 || callSessionAPI) && isSessionAPICall) {
      if (state.isDeleteAll) {
        setOligoName('')
        setSequence('')
        setCount(0)
        setSequencePreviewData({
          sequence:
            errorData.sequence.length === 0
              ? intl.formatMessage(messages.CONF_SEQUENCE_PREVIEW_HELP_TEXT)
              : '--',
          baseCount: '--',
          molecularWeight: '--',
          secondaryStructure: '--',
          primerDimer: '--',
          meltingTemperature: '--',
          gcContent: '--',
        })
        await sessionFields({
          variables: { input: [], productInput: productDetails },
        })
        dispatch({ type: 'IS_DELETE_ALL', data: false })
      } else {
        await sessionFields({
          variables: { input: obj, productInput: productDetails },
        })
      }
      dispatch({
        type: 'CALL_SESSION_API',
        data: false,
      })
    }
    setSessionAPI(true)
  }

  React.useEffect(() => {
    if (callSessionAPI) {
      sessionDataToSession(sessionData)
    }
    // TODO: need a test before we refactor these dependencies
  }, [callSessionAPI])
  const getOligoNameMaxLengthForCountry = (countryCode: string) => {
    let oligoNameMaxLength = 0
    if (countryCode === 'CN') {
      oligoNameMaxLength = Number(
        intl.formatMessage(messages.CONF_CHINA_OLIGO_NAME_MAX_LENGTH)
      )
    }
    return oligoNameMaxLength
  }

  const getOligoNameSpecialCharacter = (name): string => {
    setOligoName(name.val)
    let specialCharacter = ''
    name.val.split('').forEach((character) => {
      if (
        !character.match(oligoNameRegex) &&
        !specialCharacter.includes(character)
      ) {
        if (specialCharacter === '') {
          specialCharacter = character
        } else {
          specialCharacter = specialCharacter + ', ' + character
        }
      }
    })
    return specialCharacter
  }

  const handleToggleButton = () => {
    setIsToggleSelect(true)
    sessionData[currentOligoIndex].fullSOligoBackbone = !isToggled
    setToggle(!isToggled)
    seqInput.focus()
    dispatch({
      type: 'SPECIFICATION_TOTAL_VALIDATION',
      data: false,
    })
    dispatch({ type: 'SET_ERROR_ICON', data: false })
  }
  const handleClick = () => {
    setPosition = true
  }
  const insertAtCaret = (text) => {
    const txtarea: any = document.getElementById('sequence')
    let inputValue = txtarea.value
    if (txtarea !== null) {
      let caretPos: any = txtarea.selectionStart
      let selEnd = txtarea.selectionEnd
      if (txtarea.selectionStart === 0) {
        // if the cursor is not placed manually
        if (!setPosition) {
          if (insertPos === 0) {
            // if the base needs to be appended at the end
            caretPos = inputValue.length
            selEnd = inputValue.length
            insertPos = caretPos
          } else {
            //if the base needs to be added after the last inserted base
            caretPos = insertPos
            selEnd = caretPos
            insertPos = insertPos + text.length
          }
        } else {
          //if the cursor is placed in the first position manually
          insertPos = txtarea.selectionStart + text.length
          setPosition = false
        }
      } else {
        // if the cursor is placed to a position, update insertPos
        insertPos = txtarea.selectionStart + text.length
        setPosition = false
      }
      const front = inputValue.substring(0, caretPos)
      const back = inputValue.substring(selEnd, inputValue.length)
      inputValue = front + text + back
    }

    return inputValue
  }

  const countBases = (data) => {
    let count = 0
    if (data) {
      data = data.replace(/ *\[[^\]]*]/g, 'A')
      const baseSequence = data

      for (const seqChar of baseSequence) {
        if (
          seqChar === '*' ||
          seqChar === '+' ||
          seqChar === '\u0020' ||
          seqChar === '\u000A'
        ) {
        } else {
          count += 1
        }
      }
      setCount(count)
    } else {
      setCount(count)
    }
    sessionData[currentOligoIndex].baseCount = count
  }

  React.useEffect(() => {
    if (optionalBaseChanged) {
      const sequence = insertAtCaret(optionalBases)
      setNewText(2)
      setSequence(sequence)
      countBases(sequence)
      dispatch({ type: 'UPDATE_SEQUENCE_LENGTH', data: sequence.length })
      dispatch({
        type: 'SPECIFICATION_TOTAL_VALIDATION',
        data: false,
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, sequence: sequence },
      })
      sessionData[currentOligoIndex].sequence = sequence

      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({ type: 'OPTIONAL_BASES_CHANGED', data: false })
    }

    if (aquaInternalMod) {
      const sequence = insertAtCaret(aquaInternalMod)
      setNewText(2)
      setSequence(sequence)
      countBases(sequence)
      dispatch({ type: 'UPDATE_SEQUENCE_LENGTH', data: sequence.length })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, sequence: sequence },
      })
      sessionData[currentOligoIndex].sequence = sequence

      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({ type: 'UPDATE_AQUA_INTERNAL_MOD', data: false })
      dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    }

    if (seqInput && focusOnSequenceBox) {
      const x = window.pageXOffset
      const y = window.pageYOffset
      seqInput.focus()
      window.scrollTo(x, y) // to prevent scrolling up to the sequence field
    }
    // TODO: need a test before we refactor these dependencies
  }, [optionalBases, aquaInternalMod, optionalBaseChanged])

  const seqData = (seq) => {
    let newSequence = ''
    for (let i = 0; i < seq.length; i++) {
      const ch = seq.charAt(i)
      if (ch !== '[') {
        let data = ''
        data = ch
        if (productDetails.productType !== TubeProduct.Cpeptide) {
          newSequence = newSequence + data.toUpperCase()
        } else {
          newSequence = newSequence + data
        }
      } else {
        newSequence = newSequence + '['
        i = i + 1
        for (let j = i; j < seq.length; j++) {
          let char = seq.charAt(j)
          if (
            seq.charAt(j - 1) === '+' &&
            (productDetails.productType === TubeProduct.Beacon ||
              productDetails.productType === TubeProduct.Probe ||
              productDetails.productType === TubeProduct.Standard)
          ) {
            char = char.toUpperCase()
          }
          newSequence = newSequence + char
          if (char === ']' || j === seq.length - 1) {
            i = j
            break
          }
        }
      }
    }
    return newSequence
  }
  const callSeqValidationApi = () => {
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData, sequence: sequence },
    })
    dispatch({ type: 'UPDATE_SEQUENCE_LENGTH', data: sequence.length })
    dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    dispatch({ type: 'CONFIRM_ORDER', data: false })
    dispatch({ type: 'SET_ERROR_ICON', data: false })
    dispatch({
      type: 'SPECIFICATION_TOTAL_VALIDATION',
      data: false,
    })
  }

  React.useEffect(() => {
    if (sequence) {
      countBases(sequence)
    }
    if (seqInput && sessionData[currentOligoIndex].sequence?.length) {
      if (isToggled && productDetails.productType === TubeProduct.LongOligo) {
        seqInput.selectionEnd = sessionData[currentOligoIndex].sequence?.length
      } else seqInput.selectionEnd = insertPos
    }
    // TODO: need a test before we refactor these dependencies
  }, [sequence])

  React.useEffect(() => {
    if (sequenceValidation.length !== 0 || validateNameErrors.length !== 0) {
      dispatch({ type: 'IS_REQUIRED_FIELD_ERROR', data: true })
    } else {
      dispatch({ type: 'IS_REQUIRED_FIELD_ERROR', data: false })
    }
    const priorityErr = sessionData[currentOligoIndex].listError?.some(
      (obj) => obj.key === ConfiguratorValues.SequencePriority
    )
    //display congugation amount error if it is there, for override scenario.
    const cpeptideError =
      sessionData[currentOligoIndex].productType === TubeProduct.Cpeptide &&
      sessionData[currentOligoIndex].listError?.some(
        (obj) => obj.key === TubeProperties.ConjugationAmount
      )
    if (
      validateNameErrors.length === 0 &&
      sessionData[currentOligoIndex].isOverridden &&
      !priorityErr &&
      !cpeptideError
    ) {
      dispatch({ type: 'SET_ERROR_ICON', data: false })
      dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
    }
    // TODO: need a test before we refactor these dependencies
  }, [sequenceValidation, validateNameErrors])

  const countText = (value) => {
    insertPos = seqInput.selectionStart
    if (isToggled) {
      setNewText(newText + 1)
    }
    const mySequence = seqData(value)
    countBases(value)
    setSequence(mySequence)
    sessionData[currentOligoIndex].sequence = mySequence
  }

  const fullSOligoBackbone = (flag, changePosition) => {
    const soligoSeq: any = document.getElementById('sequence')
    let newSequence = ''
    let sequenceData = soligoSeq.value
    const { threeMod, fiveMod } = sessionData[currentOligoIndex]
    sequenceData = sequenceData.replace(/\*/g, '')
    const sequeneElement = sequenceData.trim()
    if (!sequeneElement) {
      return false
    }

    if (flag) {
      newSequence = '*'
      for (let i = 0; i < sequeneElement.length; i++) {
        if (sequeneElement.charAt(i) === '[') {
          newSequence = newSequence + sequeneElement.charAt(i)
          for (let j = i + 1; j < sequeneElement.length; j++) {
            if (sequeneElement.charAt(j) === ']') {
              i = j
              newSequence = newSequence + sequeneElement.charAt(j) + '*'
              break
            } else {
              newSequence = newSequence + sequeneElement.charAt(j)
              i++
            }
          }
        } else {
          if (
            sequeneElement.charAt(i) === ' ' ||
            sequeneElement.charAt(i) === '\n'
          ) {
            newSequence = newSequence + sequeneElement.charAt(i)
          } else {
            newSequence = newSequence + sequeneElement.charAt(i) + '*'
          }
        }
      }
      if (
        threeMod === undefined ||
        !threeMod ||
        threeMod === Modification.DefaultRnaMod
      ) {
        newSequence = newSequence.substring(0, newSequence.length - 1)
      }

      if (
        fiveMod === undefined ||
        !fiveMod ||
        fiveMod === Modification.DefaultRnaMod
      ) {
        newSequence = newSequence.substring(1, newSequence.length)
      }
    } else {
      newSequence = sequenceData.replace(/\*/g, '')
    }
    if (changePosition) {
      insertPos = newSequence.length
    } else {
      insertPos = insertPos + newText - 1
    }
    setNewText(1)

    setSequence(newSequence)
    sessionData[currentOligoIndex].sequence = newSequence
    state.errorData.sequence = newSequence
    dispatch({ type: 'IS_TUBE_ITEM_DELETE', data: false })

    if (isToggleSelect) {
      sessionData[currentOligoIndex].sequence = newSequence
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, sequence: newSequence },
      })
      setIsToggleSelect(false)
    }

    return true
  }

  const checkValidation = (response) => {
    const error: string[] = []
    const errorName: string[] = []
    const fiveModError: string[] = []
    const threeModError: string[] = []
    const fiveModThreeModErr: string[] = []
    setSequenceWarning([])
    const warningSequence: string[] = []
    const specificationWarning: string[] = []

    if (response.listErrors) {
      if (response.listWarnings) {
        response.listWarnings.forEach((obj) => {
          if (obj.key === sequenceKey) {
            warningSequence.push(obj.value)
          }
          if (obj.key === TubeProperties.Scale) {
            specificationWarning.push(obj.value)
          }
          if (obj.key === TubeProperties.Purification) {
            specificationWarning.push(obj.value)
          }
          if (obj.key === TubeProperties.Format) {
            specificationWarning.push(obj.value)
          }
          if (obj.key === TubeProperties.Concentration) {
            specificationWarning.push(obj.value)
          }
        })
      }
      dispatch({
        type: 'SPECIFICATION_WARNING_MESSAGES',
        data: specificationWarning,
      })
      response.listErrors.forEach((obj) => {
        if (isTubePageLoad) {
          if (
            obj.key === sequenceKey ||
            obj.key === ConfiguratorValues.SequencePriority
          ) {
            dispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
            error.push(obj.value)
          }
          if (obj.key === nameKey) {
            errorName.push(obj.value)
          }
          if (
            obj.key === Modification.Fivemod ||
            obj.key === Modification.FiveMod
          ) {
            fiveModError.push(obj.value)
          }
          if (
            obj.key === Modification.Threemod ||
            obj.key === Modification.ThreeMod
          ) {
            threeModError.push(obj.value)
          }
          if (obj.key === Modification.FiveModThreeMod) {
            fiveModThreeModErr.push(obj.value)
          }
        } else if (
          (productDetails.productType === TubeProduct.Aqua &&
            state.isLabelledAminoAcidError &&
            obj.key === sequenceKey) ||
          obj.key === ConfiguratorValues.SequencePriority
        ) {
          error.push(obj.value)
        } else {
          if (
            (obj.key === sequenceKey ||
              obj.key === ConfiguratorValues.SequencePriority) &&
            obj.value !== messages.CONF_REQUIRED_FIELD.defaultMessage
          ) {
            dispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
            error.push(obj.value)
          }

          if (
            (obj.key === Modification.Threemod ||
              obj.key === Modification.ThreeMod) &&
            obj.value !== messages.CONF_REQUIRED_FIELD.defaultMessage
          ) {
            threeModError.push(obj.value)
          }
          if (
            (obj.key === Modification.Fivemod ||
              obj.key === Modification.FiveMod) &&
            obj.value !== messages.CONF_REQUIRED_FIELD.defaultMessage
          ) {
            fiveModError.push(obj.value)
          }
          if (obj.key === Modification.FiveModThreeMod) {
            fiveModThreeModErr.push(obj.value)
          }
          if (
            obj.key === nameKey &&
            obj.value !== TubeProperties.RequiredField &&
            obj.value !== TubeProperties.RequiredFieldError
          ) {
            errorName.push(obj.value)
          }
        }
        if (
          error.length > 0 ||
          errorName.length > 0 ||
          fiveModError.length > 0 ||
          threeModError.length > 0
        ) {
          dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        }
      })
      dispatch({
        type: 'FIVE_MOD_ERROR',
        data: fiveModError,
      })
      dispatch({
        type: 'THREE_MOD_ERROR',
        data: threeModError,
      })
      dispatch({
        type: 'FIVEMOD_THREEMOD_ERROR',
        data: fiveModThreeModErr,
      })
      setSequenceWarning(warningSequence)
      if (
        sessionData[currentOligoIndex].sequence?.length !== 0 ||
        isTubePageLoad ||
        state.isLabelledAminoAcidError
      ) {
        setSequenceValidation(error)
      }

      if (
        validateNameErrors[0] !== TubeProperties.RequiredField &&
        validateNameErrors[0] !== TubeProperties.RequiredFieldError
      ) {
        setValidateNameErrors(errorName)
      }
    }
  }

  const checkTotalValidation = (response) => {
    const errorSequence: string[] = []
    const errorName: string[] = []
    let fiveModError: string[] = []
    let threeModError: string[] = []
    const fiveModThreeModErr: string[] = []
    const warningSequence: string[] = []
    let priorityErr = false
    let seqIsRequiredErr = false
    setSequenceWarning([])
    if (response[currentOligoIndex] === undefined) {
      return false
    }
    if (state.totalValidationJSON[currentOligoIndex].listErrors) {
      const { listErrors, listWarning } = response[currentOligoIndex]
      if (listErrors) {
        listErrors.forEach((obj) => {
          if (
            obj.key === sequenceKey ||
            obj.key === ConfiguratorValues.SequencePriority
          ) {
            errorSequence.push(obj.value)
            if (obj.value === TubeProperties.RequiredField) {
              seqIsRequiredErr = true
            }
          }
          if (obj.key === ConfiguratorValues.SequencePriority) {
            priorityErr = true
          }
          if (obj.key === nameKey) {
            errorName.push(obj.value)
          }
          if (
            obj.key === Modification.Fivemod ||
            obj.key === Modification.FiveMod
          ) {
            fiveModError.push(obj.value)
          }
          if (
            obj.key === Modification.Threemod ||
            obj.key === Modification.ThreeMod
          ) {
            threeModError.push(obj.value)
          }
          if (obj.key === Modification.FiveModThreeMod) {
            fiveModThreeModErr.push(obj.value)
          }
        })

        if (sessionData[currentOligoIndex].isOverridden && !priorityErr) {
          if (seqIsRequiredErr) {
            setSequenceValidation([
              intl.formatMessage(messages.CONF_REQUIRED_FIELD),
            ])
          } else {
            setSequenceValidation([])
          }
          fiveModError = []
          threeModError = []
        } else {
          setSequenceValidation(errorSequence)
        }

        if (sessionData[currentOligoIndex].name?.length === 0) {
          setValidateNameErrors(errorName)
        }
      }
      if (listWarning) {
        listWarning.forEach((obj) => {
          if (obj.key === sequenceKey) {
            warningSequence.push(obj.value)
          }
          if (obj.key === nameKey) {
          }
        })
      }
    }
    setValidateNameErrors(errorName)
    setSequenceWarning(warningSequence)
    dispatch({
      type: 'FIVE_MOD_ERROR',
      data: fiveModError,
    })
    dispatch({
      type: 'THREE_MOD_ERROR',
      data: threeModError,
    })
    dispatch({
      type: 'FIVEMOD_THREEMOD_ERROR',
      data: fiveModThreeModErr,
    })
    return null
  }

  React.useEffect(() => {
    if (
      state.isPageLoad === 2 &&
      !state.addOligo &&
      state.callRuleValidation === false
    ) {
      ruleValidation(state.errorData)
    }
    if (state.callRuleValidation) {
      dispatch({
        type: 'CALL_RULE_VALIDATION',
        data: false,
      })
    }
    if (state.addOligo) {
      dispatch({
        type: 'IS_ADD_OLIGO',
        data: false,
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.errorData])

  React.useEffect(() => {
    if (state.isViewAllClick) {
      dispatch({
        type: 'SPECIFICATION_TOTAL_VALIDATION',
        data: false,
      })
      dispatch({
        type: 'IS_AMOUNT_CHANGED',
        data: false,
      })
      ruleValidation(state.errorData)
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isViewAllClick])

  const setSessionData = (data) => {
    let fiveMod = ''
    let threeMod = ''
    data.fullSOligoBackbone === true ? setToggle(true) : setToggle(false)
    setOligoName(data.name)
    setSequence(data.sequence)
    countBases(data.sequence)

    if (data.fiveMod) {
      fiveMod = data.fiveMod
    }
    if (data.threeMod) {
      threeMod = data.threeMod
    }
    dispatch({ type: 'SET_ERROR_ICON', data: false })
    dispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: data.name,
        sequence: data.sequence,
        threeMod: threeMod,
        fiveMod: fiveMod,
        scale: data.scale,
        purification: data.purification,
        format: data.format,
        concentration: data.concentration,
        tubes: data.tubes,
        fullSOligoBackbone: data.fullSOligoBackbone,
        isOverridden: data.isOverridden,
        comments: data.comments,
        cterminalMod: data.cterminalMod,
        nterminalMod: data.nterminalMod,
        otherValue: data.otherValue,
        isLabelledAminoAcid: data.isLabelledAminoAcid,
        quantitation: data.quantitation,
        purityLevel: data.purityLevel,
        amount: data.amount,
        conjugation: data.conjugation,
        conjugationAmount: data.conjugationAmount,
        conjugationChemistry: data.conjugationChemistry,
        additionalCarrierProtein: data.additionalCarrierProtein,
        additionalServices: data.additionalServices,
        flag: data.flag,
      },
    })
    if (data.sequence) {
      dispatch({ type: 'UPDATE_SEQUENCE_LENGTH', data: data.sequence.length })
    } else {
      dispatch({ type: 'UPDATE_SEQUENCE_LENGTH', data: 0 })
    }
  }

  React.useEffect(() => {
    if (
      sessionData[currentOligoIndex].name !== '' ||
      sessionData[currentOligoIndex].sequence !== '' ||
      isTubePageLoad ||
      state.isLabelledAminoAcidError
    ) {
      checkValidation(state.errorResponseJson)
      if (sequenceValidation.length === 0) {
        dispatch({ type: 'UPDATE_VALID_SEQUENCE', data: true })
      }
    }

    // TODO: need a test before we refactor these dependencies
  }, [state.errorResponseJson])

  React.useEffect(() => {
    if (
      (sequenceValidation.length === 0 &&
        sessionData[currentOligoIndex].sequence?.length !== 0) ||
      sessionData[currentOligoIndex].isOverridden
    ) {
      dispatch({ type: 'UPDATE_VALID_SEQUENCE', data: true })
    } else {
      dispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
    }
    // TODO: need a test before we refactor these dependencies
  }, [sequenceValidation])

  React.useEffect(() => {
    checkTotalValidation(totalValidationJSON)
    // TODO: need a test before we refactor these dependencies
  }, [totalValidationJSON, sessionData[state.currentOligoIndex].isOverridden])

  const setShowModificationPopUp = () => {
    // condition for tubes scale Pop-Up
    let flag = false
    if (
      state.errorData.sequence.includes('[') ||
      state.errorData.threeMod !== '' ||
      state.errorData.fiveMod !== ''
    ) {
      if (
        state.errorData.threeMod.includes(Modification.DefaultRnaMod) &&
        state.errorData.fiveMod.includes(Modification.DefaultRnaMod)
      ) {
        flag = false
      } else flag = true
    } else {
      flag = false
    }

    dispatch({
      type: 'IS_MODIFICATION_POPUP',
      data: flag,
    })
  }
  React.useEffect(() => {
    setShowModificationPopUp()
    if (isToggled && !isTubeItemDelete) {
      fullSOligoBackbone(isToggled, false)
    }
    if (
      (state.seqLength !== 0 ||
        state.errorData.name?.length !== 0 ||
        state.isLabelledAminoAcidError) &&
      state.callRuleValidation === false &&
      state.isDeletePerform === false
    ) {
      state.errorData.name = oligoName
      dispatch({
        type: 'CALL_RULE_VALIDATION',
        data: false,
      })
      ruleValidation(state.errorData)
    }
    if (state.callRuleValidation) {
      dispatch({
        type: 'CALL_RULE_VALIDATION',
        data: false,
      })
    }
    if (sessionData) {
      sessionData.forEach((item) => {
        if (item.listError) {
          item.listError.forEach((element) => {
            delete element.__typename
          })
        }
        if (item.listWarning) {
          item.listWarning.forEach((element) => {
            delete element.__typename
            sessionData[currentOligoIndex].listWarning = item.listWarning
          })
        }
      })
    }
    if (
      state.sessionData[state.currentOligoIndex].name?.length !== 0 ||
      state.seqLength !== 0 ||
      isSeqEmpty ||
      state.sessionData[state.currentOligoIndex].isOverridden
    ) {
      sessionDataToSession(sessionData)
    }
    // TODO: need a test before we refactor these dependencies
  }, [sessionData])

  React.useEffect(() => {
    if (sequence && state.isPageLoad !== 1) {
      fullSOligoBackbone(isToggled, true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [isToggled])

  React.useEffect(() => {
    if (
      state.isPageLoad === 1 &&
      sessionData !== null &&
      sessionData.length !== 0 &&
      sessionData[state.currentOligoIndex] !== null &&
      Object.keys(sessionData[state.currentOligoIndex]).length !== 0
    ) {
      setSessionData(sessionData[state.currentOligoIndex])
      dispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 2,
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isPageLoad])

  const handleOligoName = () => {
    sessionData[currentOligoIndex].countryCode = productDetails.countryCode
    sessionData[currentOligoIndex].productType = productDetails.productType
    sessionData[currentOligoIndex].name = oligoName.trim()
    setSessionAPI(true)
    setIsOligoNameChange(false)
    sessionDataToSession(sessionData)
    state.errorData.name = oligoName.trim()
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData, name: oligoName.trim() },
    })
  }

  const resetValidation = () => {
    setSequenceValidation([])
    setSequenceWarning([])
    setValidateNameErrors([])
    setSeqEmpty(false)
    dispatch({ type: 'SPECIFICATION_WARNING_MESSAGES', data: [] })
    dispatch({ type: 'FIVE_MOD_ERROR', data: [] })
    dispatch({ type: 'THREE_MOD_ERROR', data: [] })
    dispatch({
      type: 'IS_DELETE_PERFORM',
      data: false,
    })
    dispatch({
      type: 'RESET_SPECIFICATION_ERROR_MSG',
      data: true,
    })
  }
  React.useEffect(() => {
    const maxItems =
      productDetails.productType === TubeProduct.iscaledna
        ? TubeProperties.MaximumOligosAllowedIscaledna
        : TubeProperties.MaximumOligosAllowed

    if (state.isResetError) {
      resetValidation()
    }
    if (
      isDeletePerform &&
      state.pageError.includes(
        intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
    ) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [isDeletePerform, currentOligoIndex])

  React.useEffect(
    () => {
      // Make sure we have a value (user has entered something in input)
      setIsSequencekeyUp(false)
      if (debouncedSequenceData) {
        if (isSequence) {
          callSeqValidationApi()
        }
        setIsSequence(false)
      }
      if (sequence === '' && isSeqEmpty) {
        setSequenceValidation([
          intl.formatMessage(messages.CONF_REQUIRED_FIELD),
        ])
        callSeqValidationApi()
      }
    },
    // This is the useEffect input array
    // Our useEffect function will only execute if this value changes ...
    // ... and thanks to our hook it will only change if the original ...
    // value (searchTerm) hasn't changed for more than 500ms.
    // TODO: need a test before we refactor these dependencies

    [debouncedSequenceData]
  )

  return (
    <div className={classes.contentWrapper}>
      <Box>
        <Formik
          initialValues={{}}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <h4 className={classes.subHead}>
                <FormattedMessage
                  {...messages[`CONF_SEQUENCE_INFORMATION_${product}`]}
                />
              </h4>
              <Grid container spacing={10}>
                <Grid item xs={7}>
                  <Field
                    name="name"
                    component={LiquidInputAdapter}
                    label={<OligoNameInfoIcon />}
                    value={oligoName || ''}
                    onBlur={handleOligoName}
                    filled
                    spellcheck={'false'}
                    validate={(value) => {
                      if (value === undefined) {
                        value = oligoName
                      }
                      sessionData[currentOligoIndex].name = validateText(
                        value.trim()
                      )
                      setSessionAPI(false)
                      !sessionData[currentOligoIndex].sequence?.length &&
                        setIsOligoNameChange(true)
                      dispatch({
                        type: 'UPDATE_INPUT',
                        data: [...state.sessionData],
                      })
                      dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
                      dispatch({ type: 'SET_ERROR_ICON', data: false })
                      const val = validateText(convertToASCII(value))
                      const oligoNameSpecialCharacter =
                        getOligoNameSpecialCharacter({ val })
                      const validator = yup
                        .string()
                        .trim()
                        .required(
                          intl.formatMessage(messages.CONF_REQUIRED_FIELD)
                        )
                        .max(
                          getOligoNameMaxLengthForCountry('CN'),
                          intl.formatMessage(
                            messages[`CONF_MAX_OLIGO_NAME_LENGTH_30_${product}`]
                          ) + getOligoNameMaxLengthForCountry('CN')
                        )
                        .matches(
                          /^[a-zA-Z0-9_#*()., +.[\-\]/]*$/,
                          oligoNameSpecialCharacter
                            ? intl.formatMessage(
                                messages.CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE
                              ) + oligoNameSpecialCharacter
                            : ' '
                        )
                      const errors: string[] = []
                      try {
                        setValidateNameErrors([])
                        validator.validateSync(val, { abortEarly: false })
                        if (
                          state.isComingFromReviewPage &&
                          sessionData[currentOligoIndex].listError?.length === 2
                        ) {
                          sessionData[currentOligoIndex].listError.forEach(
                            (err) => {
                              if (err.key === nameKey) {
                                sessionData[currentOligoIndex].listError = []
                              }
                            }
                          )
                        }
                      } catch (error: any) {
                        if (error.errors && error.errors[0] !== ' ') {
                          for (const err of error.errors) {
                            errors.push(err)
                          }

                          setValidateNameErrors(errors)
                        } else {
                          sessionData[currentOligoIndex].listError.length = 0
                          setValidateNameErrors([])
                        }
                      }
                      return undefined
                    }}
                    className={classes.sequenceInput}
                  />
                  <div
                    className={clsx(
                      classes.baseContent,
                      globalClasses.globalHelpTextColor
                    )}
                  >
                    {intl.formatMessage(
                      messages[
                        `CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_${product}`
                      ]
                    )}
                  </div>
                  <div>
                    <ValidationErrors errors={validateNameErrors} />
                  </div>
                </Grid>
              </Grid>
              {oligoName.trim().length > 18 ? (
                <div className={classes.warningBox}>
                  <OligoNameWarning
                    warning={intl.formatMessage(
                      messages.CONF_OLIGO_NAME_WARNING
                    )}
                  />
                </div>
              ) : (
                ''
              )}
              <Grid container direction="row" className={classes.mt20}>
                <Grid item xs={6}>
                  <FormLabel className={classes.label}>
                    <FormattedMessage {...messages.CONF_SEQUENCE_LABEL} />
                    &nbsp;
                    <span className={classes.sequenceType}>
                      <FormattedMessage
                        {...messages[`CONF_SEQUENCE_TYPE_${product}`]}
                      />
                    </span>
                  </FormLabel>
                  {product === TubeProduct.Aqua ||
                  product === TubeProduct.Rna ? (
                    <Tooltip
                      className={classes.tootltip}
                      title={
                        product === TubeProduct.Rna ? (
                          <FormattedMessage
                            {...messages.CONF_SEQUENCE_MESSAGE}
                          />
                        ) : product === TubeProduct.Aqua ? (
                          <FormattedMessage
                            {...messages.CONF_AQUA_SEQUENCE_INFO_ICON_MESSAGE}
                          />
                        ) : (
                          ''
                        )
                      }
                      classes={{
                        tooltip: classes.InfoPopup,
                        arrow: classes.arrow,
                      }}
                      arrow
                      placement="bottom-end"
                    >
                      <InfoIcon color="primary" className={classes.InfoIcon} />
                    </Tooltip>
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={10}>
                <Grid item xs={12}>
                  <Field
                    name="sequence"
                    id="sequence"
                    component={LiquidInput}
                    className={clsx(classes.sequenceEntry)}
                    filled
                    multiline
                    autoComplete="off"
                    onChange={(e) => {
                      setIsOligoNameChange(false)
                      setSeqEmpty(true)
                      setIsSequencekeyUp(true)
                      countText(validateText(convertToASCII(e.target.value)))
                      setIsSequence(true)
                    }}
                    onClick={handleClick}
                    spellcheck={'false'}
                    value={sequence}
                  />
                  <div
                    className={clsx(
                      classes.baseContent,
                      globalClasses.globalHelpTextColor,
                      globalClasses.sequenceBaseCountText
                    )}
                  >
                    <span>{instructions}</span>
                    {product === TubeProduct.iscaledna ? (
                      <>
                        <span className={globalClasses.boldCss}>
                          <FormattedMessage
                            {...messages[`CONF_BASE_COUNT_${product}`]}
                          />
                        </span>
                        <span>
                          {isSequencekeyUp
                            ? count
                            : sequenceValidation.length === 0
                              ? count
                              : ' --'}
                        </span>
                      </>
                    ) : (
                      <span>
                        <FormattedMessage
                          {...messages[`CONF_BASE_COUNT_${product}`]}
                        />
                        {isSequencekeyUp
                          ? count
                          : sequenceValidation.length === 0
                            ? count
                            : ' --'}
                      </span>
                    )}
                  </div>
                  <div
                    className={clsx(
                      classes.baseContent,
                      globalClasses.globalHelpTextColor
                    )}
                  >
                    {productDetails.productType === TubeProduct.Cpeptide &&
                    productDetails.countryCode === 'JP'
                      ? ''
                      : intl.formatMessage(
                          messages[`CONF_SEQUENCE_MESSAGE_${product}`]
                        )}
                  </div>
                  {productDetails.countryCode === 'JP' &&
                  product === TubeProduct.Cpeptide ? (
                    <Typography
                      variant="body2"
                      className={classes.sequenceHelperText}
                    >
                      <FormattedMessage
                        id="SEQUENCE_MESSAGE_N_TERM_C_TERM"
                        defaultMessage="Sequence must contain a cysteine (C) at the N-term or C-term sequence position if conjugation is required."
                      />
                    </Typography>
                  ) : (
                    ''
                  )}
                  <div>
                    <ValidationErrors errors={sequenceValidation} />
                    <ValidationWarnings warnings={sequenceWarning} />
                  </div>
                </Grid>
              </Grid>

              {product === TubeProduct.Standard ||
              product === TubeProduct.Rna ||
              product === TubeProduct.LongOligo ||
              product === TubeProduct.iscaledna ? (
                <Grid container spacing={10}>
                  <Grid item>
                    <FormLabel
                      component="legend"
                      className={classes.switchLabel}
                    >
                      <FormattedMessage {...messages.CONF_FULL_OLIGO} />
                      <Box
                        component="span"
                        className={clsx(
                          classes.baseContent,
                          globalClasses.globalHelpTextColor
                        )}
                      >
                        {product === TubeProduct.iscaledna ? (
                          <FormattedMessage
                            {...messages.CONF_FULL_OLIGO_INFO_ISCALE}
                          />
                        ) : (
                          <FormattedMessage
                            {...messages.CONF_FULL_OLIGO_INFO}
                          />
                        )}
                      </Box>
                    </FormLabel>
                    <Field
                      name="fullSOligoBackbone"
                      component={Switch}
                      filled="true"
                      value={isToggled}
                      checked={isToggled}
                      classes={{
                        root: globalClasses.switchRoot,
                        track: globalClasses.switchTrack,
                        switchBase: globalClasses.switchBase,
                        checked: globalClasses.checked,
                        thumb: globalClasses.thumb,
                        input: globalClasses.switchInput,
                      }}
                      onChange={handleToggleButton}
                    />
                  </Grid>
                </Grid>
              ) : (
                ''
              )}
            </>
          )}
        </Formik>
      </Box>
    </div>
  )
}

export default SequenceInfo
